function About() {
  return (
    <>
      <div className="flex flex-col lg:flex-row justify-between mt-[13%] items-center  w-full px-4 py-8 lg:py-0">
        {/* Left Section */}
        <div className="w-full lg:w-1/2 flex flex-col md:ms-10  items-start justify-center text-left Fira">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-semibold  mb-6 max-w-[90%] text-shadow">
            Built on Legacy, Driven by Innovation
          </h1>
          <p className="text-lg md:text-xl mb-6 max-w-[90%] text-gray-800">
            For over two decades, KSU has been at the forefront of stainless steel hinge
            manufacturing, delivering precision-engineered solutions that define industry
            standards.
          </p>
          <p className="text-lg md:text-xl max-w-[90%] text-gray-800">
            Our commitment to excellence drives every aspect of our manufacturing process,
            from material selection to final quality control.
          </p>
        </div>

        {/* Right Section */}
        <div className="w-full lg:w-1/2 mt-10 lg:mt-0 flex justify-center">
          <div className="w-full max-w-[90%] lg:max-w-[80%]">
            <img
              src="about.svg"
              alt="About KSU"
              className="w-full h-auto rounded-lg object-cover object-center"
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default About;
